// Deals. The pages themselves are apps/portal/src/deals/ (module 10 U151, U152; the brief
// DEALS-PAGE-BRIEF-2026-09-22.md sections 4 and 6). This file stays where it is so that App.tsx's
// import keeps working: App.tsx belongs to the portal track and two tracks never hold one file
// (infra/agent-guard/OWNERS).
//
// It takes an OPTIONAL id, so the one line App.tsx needs is
//     case 'deals': body = <Deals {...props} id={surface.id} />; break;
// which is correct whether or not an id is in the path, and which track `show` is making in the
// same edit that adds /deals/shows/:id. The deals half of that line was made by track `dealspage`
// on 2026-09-22 (a commit of its own, under track portal); the shows half is track `show`'s.
//
// What was here until 2026-09-22 was the HubSpot-shaped table this replaces: Matter, Counterparty,
// Product, Origin, Stage, How positive, Value, Expected close, Reason — columns that said nothing
// about what moved, what is owed or whose it is, and which scrolled sideways at 900px. Mike, on the
// page it came from: "it was built from a construct that came out of Hubspot without any great
// levels of thinking."
import type { PageProps } from './shared.js';
import { AddDealPage } from '../dealwork/AddDealPage.js';
import { DealPage } from '../deals/DealPage.js';
import { HeatPage } from '../deals/HeatPage.js';
import { NotesPage } from '../notes/NotesPage.js';
import { ShowPage } from '../show/ShowPage.js';

export function Deals({ id, ...props }: PageProps & { id?: string | undefined }) {
  // /deals/shows/:id is a show's day sheet (U160), track `show`'s page; App.tsx hands it here as `shows/<id>`.
  if (id?.startsWith('shows/')) return <ShowPage {...props} id={id.slice('shows/'.length)} />;
  // /deals/notes is the reader's own notes (U209, pipeline I2), track `notes`'s page.
  if (id === 'notes') return <NotesPage {...props} />;
  // /deals/new is Add deal, a page of its own (U286, the Deal work lane's W6); ?company= opens it with the company set.
  if (id === 'new') return <AddDealPage {...props} />;
  // /deals is accounts by heat (P4, U218): the desk of 24 Sep it replaces stays in DealsPage.tsx, whose proposal cards
  // this page draws.
  return id ? <DealPage {...props} id={id} /> : <HeatPage {...props} />;
}
